import type { User } from "../types/user.types";
import { useAuth } from "@certa/auth/AuthenticationProvider";

export const useCurrentUser = (): User => {
  const { user } = useAuth();
  return user!;
};
